var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.community
        ? "roboroboPersonal communityPersonal"
        : "roboroboPersonal",
    },
    [
      _c("div", { staticClass: "top" }, [
        _c("ul", { staticClass: "infoBox" }, [
          _c("li", [
            _c("span", [_vm._v("用户账号")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentUser.phone,
                  expression: "currentUser.phone",
                },
              ],
              staticClass: "inputText",
              attrs: { disabled: "", type: "text" },
              domProps: { value: _vm.currentUser.phone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.currentUser, "phone", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("真实姓名")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentUser.name,
                  expression: "currentUser.name",
                },
              ],
              staticClass: "inputText",
              attrs: { disabled: true, type: "text" },
              domProps: { value: _vm.currentUser.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.currentUser, "name", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("性  别")]),
            _vm._v(" "),
            _c("div", { staticClass: "sexBox" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentUser.sex,
                      expression: "currentUser.sex",
                    },
                  ],
                  staticClass: "radio_type",
                  attrs: { name: "age", type: "radio", value: "男" },
                  domProps: { checked: _vm._q(_vm.currentUser.sex, "男") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.currentUser, "sex", "男")
                    },
                  },
                }),
                _vm._v("男"),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentUser.sex,
                      expression: "currentUser.sex",
                    },
                  ],
                  staticClass: "radio_type",
                  attrs: { name: "age", type: "radio", value: "女" },
                  domProps: { checked: _vm._q(_vm.currentUser.sex, "女") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.currentUser, "sex", "女")
                    },
                  },
                }),
                _vm._v("女"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("生  日")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentYear,
                    expression: "currentYear",
                  },
                ],
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentYear = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    (e) => (_vm.currentYear = e.target.value),
                  ],
                },
              },
              _vm._l(_vm.years, function (item, index) {
                return _c("option", { key: index, domProps: { value: item } }, [
                  _vm._v(_vm._s(item)),
                ])
              }),
              0
            ),
            _vm._v("年\n                "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentMonths,
                    expression: "currentMonths",
                  },
                ],
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentMonths = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    (e) => (_vm.currentMonths = e.target.value),
                  ],
                },
              },
              _vm._l(_vm.months, function (item, index) {
                return _c("option", { key: index, domProps: { value: item } }, [
                  _vm._v(_vm._s(item)),
                ])
              }),
              0
            ),
            _vm._v("月\n                "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentDay,
                    expression: "currentDay",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.currentDay = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.days, function (item, index) {
                return _c("option", { key: index, domProps: { value: item } }, [
                  _vm._v(_vm._s(item)),
                ])
              }),
              0
            ),
            _vm._v("日\n            "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("button", { on: { click: _vm.submitChangeInfo } }, [
              _vm._v("确认修改"),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "avatarBox" },
          [
            _vm.community
              ? _c("ImageCropping", {
                  attrs: { img: _vm.currentUser.avatar },
                  on: { changeAvatar: _vm.changeAvatar },
                })
              : _c("ImageCropping", {
                  attrs: {
                    img: _vm.currentUser.avatar.endsWith(
                      `static.${_vm.institutionConfig.baseDomainName}/noavatar.png`
                    )
                      ? _vm.defaultAvatar
                      : _vm.currentUser.avatar,
                  },
                  on: { changeAvatar: _vm.changeAvatar },
                }),
            _vm._v(" "),
            _c("span", [_vm._v("点击更换头像")]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "line" }),
      _vm._v(" "),
      (_vm.community ? _vm.tourist : true)
        ? _c("ul", [
            _vm.tourist
              ? _c("li", [
                  _c("span", [_vm._v("微信通知")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wxBox" }, [
                    _vm.currentUser.wxNickname
                      ? _c("div", { staticClass: "wxUserInfo" }, [
                          _c("img", {
                            staticClass: "wxHeadImg",
                            attrs: { src: _vm.currentUser.wxHeadImg, alt: "" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.currentUser.wxNickname)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-circle-plus",
                      on: { click: _vm.geterweoma },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.community
              ? _c("li", { staticClass: "btnflex" }, [
                  _c("button", { on: { click: _vm.changePassword } }, [
                    _vm._v("修改密码"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "logoutBtn", on: { click: _vm.logOut } },
                    [_vm._v("退出登录")]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "微信扫码绑定",
            visible: _vm.erweimaDialogVisible,
            width: "190px",
            "close-on-click-modal": false,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.erweimaDialogVisible = $event
            },
            close: _vm.closeErweimDialog,
          },
        },
        [_c("div", { attrs: { id: "qrcode" } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/personal.vue?vue&type=template&id=0e99d250&
// module id = null
// module chunks = 